<div tourAnchor="series.dashboard.summary">
  <div class="series-summary">
    <div class="series-title flex min-h-10 p-0 flex-wrap">
      <div class="pt-1 font-bold text-md lg:text-2xl" data-cy="seriesLabel">{{seriesName()}}</div>
      <div class="text-sm p-1.5 ml-0 lg:pt-3 flex text-label-color font-normal" data-cy="asOfDateLabel">as of
        {{selectedAsOfDate() | dateFormat : 'MM/dd/yyyy'}}
        @if (portfolioSummary()?.publishValuationType === 'Audit') {
        <div class="final" data-cy="auditPublished">-- Final</div>
        }
      </div>
    </div>
    <div>
      <div class="flex">
        @for (assetImage of assetClassImage(); track assetImage[0]; let i = $index;) {
        <img class="investment-type" [src]="assetImage[1]" [matTooltip]="assetImage[0]" matTooltipClass="blue-tooltip"
          matTooltipPosition="right" [ngClass]="{'ml-2.5': i !== 0}" alt="{{assetImage[0]}}">
        }
      </div>
      <app-series-summary-card [iconSet]="iconSet()" [currency]="portfolioSummary()?.currency"
        [seriesSummary]="seriesSummary()"></app-series-summary-card>
    </div>
  </div>